var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row form-group mt-3 mb-4" },
    [
      _vm.title
        ? _c(
            "label-control",
            {
              staticClass: "col-xs-12 col-sm-5 col-form-label",
              attrs: { title: _vm.title, required: _vm.attachment.isRequired }
            },
            [_vm._v(_vm._s(_vm.$t(_vm.title)))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.title ? "col-xs-12 col-sm-7 form-row-content" : "col-xs-12"
          ]
        },
        [
          _c("attachment-wrapper", {
            attrs: {
              attachment: _vm.attachment,
              index: _vm.index,
              notifyonuploadedsuccess: _vm.notifyonuploadedsuccess,
              isDuplicatedFileName: _vm.isDuplicatedFileName
            },
            on: {
              "added-attachment": function($event) {
                return _vm.$emit("added-attachment", _vm.attachment)
              }
            },
            model: {
              value: _vm.attachment,
              callback: function($$v) {
                _vm.attachment = $$v
              },
              expression: "attachment"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }